
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-1">
            <div className="flex items-center mb-6">
              <img src="/logo.jpg" alt="Raah Global" className="h-10 w-auto" />
              <span className="ml-3 text-xl font-bold">Raah Global</span>
            </div>

            {/* Partner Section */}
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-gray-300 mb-3 uppercase tracking-wide">
                Official Partners
              </h4>
              <div className="flex flex-wrap items-center gap-4">
                <div className="flex items-center bg-white/10 px-3 py-2 rounded-lg backdrop-blur-sm">
                  <img
                    src="/sublogo.png"
                    alt="Partner Logo 1"
                    className="h-8 w-auto opacity-90 hover:opacity-100 transition-opacity"
                  />
                </div>
                <div className="flex items-center bg-white/10 px-3 py-2 rounded-lg backdrop-blur-sm">
                  <img
                    src="/sublogo2.png"
                    alt="Partner Logo 2"
                    className="h-8 w-auto opacity-90 hover:opacity-100 transition-opacity"
                  />
                </div>
              </div>
            </div>

            <p className="text-gray-400 mb-4 text-sm leading-relaxed">
              Your trusted partner in international education. We help students
              achieve their dreams of studying at top universities in South
              Korea.
            </p>
            <p className="text-gray-400 mb-6 text-xs">
              Business Reg: 등록번호 : 815-79-00669 | Raah Global ( 라아 글로벌
              )
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/179fgcDg9h/?mibextid=wwXIfr"
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/rhglobals?igsh=MXJ6NXhmbmx1NzVuZQ=="
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Instagram
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/courses"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Programs
                </a>
              </li>
              <li>
                <a
                  href="/universities"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Universities
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/pricing"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400">
              <li>Email: info@raahglobalpak.kr</li>
              {/* <li>Phone Number: +923193943911</li> */}
              {/* <li>
                Address: Office # 60-63, Marhaba Plaza, Qambar Bypass Road, Near
                New General Bus Stand, Mingora, Swat, KPK, Pakistan
              </li> */}
            </ul>
          </div>
          {/* Legal & Policies */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal & Policies</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/privacy-policy"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms-of-service"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="/refund-policy"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-center md:text-left">
              &copy; 2025 Raah Global. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a
                href="/privacy-policy"
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Privacy
              </a>
              <a
                href="/terms-of-service"
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Terms
              </a>
              <a
                href="/refund-policy"
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                Refunds
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
